import React, { useEffect, useState, useRef } from "react";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { baseURL, fetch, post, postForm } from "../../Util/axios_helper";
import { useDispatch, useSelector } from "react-redux";
import {
  getNoofAttendeesList,
  getWhatsincludeList,
  getFunctionTypesEvent,
  getBallRoomList,
} from "./configuration_slice";
import { KendoLoader } from "../../Kendo/kendo_loader";
import { KendoEditor } from "../../Kendo/kendo_editor";
import {
  Button,
  ErrorMsg,
  GetFormData,
  ValidateForm,
  checkAccess,
  sessionUser,
} from "../../Util/common";

export const WhatsInclude = ({ selTab }) => {
  const dispatch = useDispatch();
  const { whatsincludeList, whatsincludeListLoaded, Futures } = useSelector(
    (state) => state.configuration
  );
  const [error, setError] = useState({});
  const [Loading, setLoading] = useState(false);
  const [whatsInclude, setWhatsInclude] = useState({
    BallRoomId: 0,
    BallRoomName: "",
    Futures: "",
    refresh: 0,
  });

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const clearForm = () => {
    setError({});
    setWhatsInclude({
      BallRoomId: 0,
      BallRoomName: "",
      Futures: "",
    });
  };

  useEffect(() => {
    if (selTab == 2) {
      dispatch(getWhatsincludeList());
      dispatch(getBallRoomList());
    }
  }, [selTab]);

  const onSubmit = async (e) => {
    e.preventDefault();
    var err = ValidateForm(e);
    if (err) {
      setError(err);
    } else {
      setLoading(true);
      var data = GetFormData(e);
      data.SavedBy = sessionUser();
      await post("Configuration/SaveWhatsInclude", data, true, true, false);
      setLoading(false);
      $("#hide").click();
      $("#ballroom-whatsinclude-cancel").click();
      dispatch(getWhatsincludeList());
    }
  };

  const handleEditClick = (e) => {
    let refresh = whatsInclude.refresh;
    setWhatsInclude({
      BallRoomId: e.BallRoomId,
      BallRoomName: e.BallRoomName || "",
      Futures: e.Futures || "",
      refresh: refresh + 1,
    });
    $("#add_whatsinclude").modal("show");
  };

  return (
    <>
      <div className="col-auto ms-auto">
        <div className="row">
          <div className="col-sm-6"></div>
          <div className="col-auto float-end ms-auto">
            <div className="d-flex justify-content-end mb-2"></div>
          </div>
        </div>

        <div>
          {!whatsincludeListLoaded ? (
            <div className="col-12">
              <KendoLoader />
            </div>
          ) : (
            <KendoGrid
              name={"whatsinclude-config"}
              data={whatsincludeList}
              columns={[
                {
                  field: "BallRoomId",
                  filterable: false,
                  hidden: true,
                },
                {
                  field: "WhatsIncludeId",
                  filterable: false,
                  hidden: true,
                },
                {
                  field: "BallRoomName",
                  title: "Ballroom",
                  width: "160px",
                },
                {
                  template: function (e) {
                    if (e.Futures) {
                      return `<div style="max-height: 340px;overflow:auto">${e.Futures}</div>`;
                    }
                    return "";
                  },
                  field: "Futures",
                  title: "Content",
                },
              ]}
              showOptions={
                !checkAccess("EMAILCONFIGCREATE") ||
                checkAccess("EMAILCONFIGEDIT")
              }
              showDelete={false}
              onEditClick={handleEditClick}
              disableExportExcel={true}
              optionWidth={"80px"}
            />
          )}
        </div>
      </div>
      {/* <!-- Add Quote Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_whatsinclude"
        role="dialog"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-xl"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{whatsInclude.BallRoomName}</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-whatsInclude-config" onSubmit={onSubmit}>
                <input
                  type="hidden"
                  value={whatsInclude.BallRoomId}
                  name="BallRoomId"
                />
                <div className="input-block mb-3">
                  <label>
                    What is Included? <span className="text-danger">*</span>
                  </label>

                  <KendoEditor
                    name="Futures"
                    imageBrowser={{
                      enable: true,
                      read: baseURL + "EmailTemplate/GetImages",
                      upload: baseURL + "EmailTemplate/UploadImage",
                      delete: baseURL + "EmailTemplate/DeleteImage",
                      image: baseURL + "EmailTemplate/GetImage?path={0}",
                      thumbnail: baseURL + "EmailTemplate/GetThumbnail",
                    }}
                    height={"441px"}
                    value={whatsInclude.Futures}
                    required={true}
                    onValidate={onValidation}
                    refreshWhen={whatsInclude.refresh}
                    createLink={false}
                    unlink={false}
                  />
                  {error.Futures && <ErrorMsg text="*required" />}
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="ballroom-whatsinclude-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    />
                    <Button name={"Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Add Quote Modal --> */}
    </>
  );
};
